"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _deepCompareEquals = _interopRequireDefault(require("../../utils/deepCompareEquals"));
var _usePreviousPersistent = _interopRequireDefault(require("../usePreviousPersistent"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var useDidValueChanged = function useDidValueChanged(value, isEqual) {
  if (isEqual === void 0) {
    isEqual = _deepCompareEquals.default;
  }
  var prev = (0, _usePreviousPersistent.default)(value);
  return !isEqual(prev, value);
};
var _default = useDidValueChanged;
exports.default = _default;